import { render, staticRenderFns } from "./CusipAgreement.vue?vue&type=template&id=1060bb67&scoped=true&"
import script from "./CusipAgreement.vue?vue&type=script&lang=js&"
export * from "./CusipAgreement.vue?vue&type=script&lang=js&"
import style0 from "./CusipAgreement.vue?vue&type=style&index=0&id=1060bb67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1060bb67",
  null
  
)

export default component.exports